<template lang="pug">
  .sold-consumer
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Code
        th Disposition
        th Business Step
        th Package
        th Product
        th User
        th Event Time
      tr(v-for="s in sold")
        td.kzcode-default {{s.package.code}}
        td {{s.disposition | disposition}}
        td {{s.bizStep | bizStep}}
        td
          span(v-if="s.package") {{s.package.packageType.name}}
        td
          span(v-if="s.product.name") {{s.product.name}}
        td {{s.user.username}}
        td {{s.eventTime | date}}

    IndefinitePagination(:fetch="fetchData")
</template>

<script>
import TrackNTrace from '@/service/apis/TrackNTrace'
import GenericTable from '@/components/common/GenericTable'
import IndefinitePagination from '@/components/common/IndefinitePagination'
import { dateFilter } from '@/filters/filters'
import { bizStepFilter, dispositionFilter } from '@/components/pages/trackntrace/utils'
import Page from '@/utils/common'

export default {
  data: () => ({
    loading: false,
    pg: new Page({ page: 1, size: 15 }),
    sold: null
  }),
  methods: {
    fetchData(params) {
      const req = params
      this.loading = true
      req.locationId = this.locationId
      return TrackNTrace.getLocationSoldItems(req)
        .then((resp) => {
          this.sold = resp.data.event
          this.loading = false
          return resp.data.hasMore
        })
        .catch((e) => { this.$emit('error', e) })
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    IndefinitePagination
  },
  filters: {
    date: dateFilter,
    disposition: dispositionFilter,
    bizStep: bizStepFilter
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/SoldConsumer.vue